module.exports = __webpack_public_path__ + "img/1557614099738730497.4e98b678.png";